if ($('.plusminus-cards').length) {
    $('.btn-plus').click(function(){
        $(this).prev('input').val(parseInt($(this).prev('input').val()) + 1);
    });
    $('.btn-minus').click(function(){
        if(parseInt($(this).next('input').val()) != 0){
            $(this).next('input').val(parseInt($(this).next('input').val()) - 1);
        }
    });
}